<template>
  <tr>
    <td class="w-100">
      <div class="mobile-table-item">
        <div class="mobile-table-item__select">
          <checkbox @change="$emit('update:checked')" :checked="checked" />
        </div>
        <div class="mobile-table-item__values">
          <div class="mobile-table-item__group">
            <div
              class="mobile-table-item__row"
              v-for="header in displayHeaders"
              :key="header.value"
            >
              <div
                class="mobile-table-item__header"
                @click="handleSort(header)"
              >
                {{ $t(`table.header.${header.text}`) }}
              </div>
              <div class="mobile-table-item__value">
                <template v-if="header.value === 'date'">
                  <div class="p-3" v-html="formatDate(item.date)" />
                </template>
                <template v-else-if="header.value === 'type'">
                  <status-label
                    :small="true"
                    :value="item.type"
                    :status="typeColor(item.type)"
                  />
                </template>
                <template v-else-if="header.value === 'database' || header.value === 'directory'">
                  <v-icon
                    v-if="item[header.value]"
                    size="20"
                    color="primary"
                    class="ms-4"
                  >$checkcircle</v-icon>
                </template>
                <template v-else>
                  <span class="p-3">{{ formatValue(item[header.value]) }}</span>
                </template>
              </div>
            </div>
          </div>
          <div class="mobile-table-item__group">
            <div class="mobile-table-item__actions">
              <v-btn icon small @click="$emit('action-button-download', item)"
                ><v-icon>$update</v-icon></v-btn
              >
              <v-btn icon small @click="$emit('action-button-restore', item)"
                ><v-icon>$restore</v-icon></v-btn
              >
              <v-btn icon small @click="$emit('action-button-delete', item)"
                ><v-icon>$thrash</v-icon></v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import StatusLabel from "../StatusLabel.vue";
import Checkbox from "../buttons/Checkbox.vue";

export default {
  components: {
    StatusLabel,
    Checkbox,
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
    },
    item: Object,
    checked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayHeaders() {
      return (this.headers || []).filter(
        (h) => h && h.value !== "select" && h.value !== "actions"
      );
    },
  },
  methods: {
    handleSort(header) {
      if (header && header.sortable) {
        this.$emit("update:sortBy", header);
      }
    },
    formatValue(value) {
      if (value === null || value === undefined || value === "") return "---";
      return value;
    },
    typeColor: function (value) {
      if (value == "Automatic") {
        return "primary";
      } else if (value == "Manual") {
        return "purple";
      }
    },

    formatDate: function (value) {
      if (!value) return "---";

      if (typeof value === "string") {
        value = parseInt(value);
      }

      var options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      const formatedDate = new Date(value).toLocaleDateString(
        undefined,
        options
      );

      let date = formatedDate.slice(0, formatedDate.indexOf(","));
      let time = formatedDate.slice(
        formatedDate.indexOf(",") + 1,
        formatedDate.length
      );
      date = `<span class="font-weight-bold">${date}</span>`;
      return date + time;
    },
  },
};
</script>


<style lang="scss" scoped>
td,
tr {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
}

.checkbox::v-deep {
  .v-input .v-input__control .v-input__slot {
    min-height: unset !important;
  }
}
</style>